import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Image, Table, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { get_vendor_settlement } from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { SINGLE_VENDOR_SETTLEMENT } from "../../../../store/types";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import SelectFilter from "../../../reusableComponents/selectFilter";
import isEmpty from "../../../../store/validation/is-Empty";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import { Modal } from "react-bootstrap";
import { amApi } from "../../../../api/apiHelper";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import Alert from "react-s-alert";

const SAViewPayoutDetailsPopup = (props) => {
  const [details, setDetails] = useState([]);
  useEffect(() => {
    async function fetchData() {
      let selected = props.selected.map(ele => ele._id)
      let params = {
        selectedIds: selected,
        getStatus: true
      }
      let response = await amApi.get(`/settlement_process`, { params: params });
      if (response.status) {
        let allRecords = [];
        for (const record of response.data) {
          allRecords = [...allRecords, ...record.records]
        }
        setDetails(allRecords);
      }
    }
    fetchData()
  }, [props.selected])


  const handleProcess = async () => {
    let selected = props.selected.map(ele => ele._id)
    let body = {
      "selectedIds": selected,
      "status": "PROCESSED"
    }
    let response = await amApi.patch('/settlement_process', body);
    if (response.status === 200) {
      Alert.success(`<h4>Payout Initiated Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    props.hidePopup()
  }

  return (
    <React.Fragment>
      <Modal show={true} onHide={props.hidePopup} centered size="lg">
        <Modal.Header className="border-0" closeButton>
        </Modal.Header>
        {!props.showStatus && <><div className="f18-700 pl-4 pb-2">Payout Details</div>
          <div className="f10-400 pl-4">Please check the details before placing the request</div></>}
        {props.showStatus && <><div className="f18-700 pl-4 pb-2">Payout Details</div>
        </>}
        <Modal.Body>
          {/* <div className="f24_700_HelveticaNeue w-75 m-auto pb-4"></div> */}
          {!props.showStatus && <div className="f14-700 mb-4">Check Merchant Details</div>}
          {props.showStatus && <div className="f14-700 mb-4">Merchant Payout Status</div>}
          <TableHead showStatus={props.showStatus} />
          {details.length && details.map(record => <TableBody data={record} key={record._id} showStatus={props.showStatus} />)}
          {(!props.showStatus || props.selected[0].settlement_status === 'PARTIAL' || props.selected[0].settlement_status === 'FAILED') && <div className="mt-4">
            <div className="row">
              <div className="col-3">

              </div>
              <div className="col-3">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  // onClick={(e) =>
                  //   this.props.history.push("/subscriptiondescription")
                  // }
                  onClick={props.hidePopup}
                >
                  {(props.selected[0].settlement_status === 'PARTIAL' || props.selected[0].settlement_status === 'FAILED') ? 'Cancel' : 'No'}
                </Button>
              </div>
              <div className="col-3">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  // style={{ width: "90%" }}
                  onClick={handleProcess}
                >
                  {(props.selected[0].settlement_status === 'PARTIAL' || props.selected[0].settlement_status === 'FAILED') ? 'Re-initiate Payout' : 'Yes'}
                </Button>
              </div>
              <div className="col-3">

               </div>
            </div>
          </div>}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
SAViewPayoutDetailsPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  get_vendor_settlement: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_vendor_settlement:
    state.superadminManageTransactions.all_vendor_settlement,
});

export default connect(mapStateToProps, {
  get_vendor_settlement,
})(SAViewPayoutDetailsPopup);

const TableHead = (props) => {
  return (
    <tr>
      {props.showStatus && <th style={{ width: "6%", fontSize: '10px', color: 'grey' }}>
      </th>}
      <th style={{ width: "15%", fontSize: '10px', color: 'grey' }}>
        Restaurant <br />
        Name/ID
      </th>
      <th style={{ width: "14%", fontSize: '10px', color: 'grey' }}>
        Ordering <br />
        Amount
      </th>
      <th style={{ width: "14%", fontSize: '10px', color: 'grey' }}>
        Experience <br /> Amount
      </th>
      <th style={{ width: "14%", fontSize: '10px', color: 'grey' }}>
        Scan & Pay <br />
        Amount
      </th>
      <th style={{ width: "14%", fontSize: '10px', color: 'grey' }}>
        Tip <br />
        Amount
      </th>
      <th style={{ width: "14%", fontSize: '10px', color: 'grey' }}>
        Total <br /> Amount
      </th>
      <th style={{ width: "14%", fontSize: '10px', color: 'grey' }}>
        Type of <br />
        Account
      </th>
      <th style={{ width: "20%", fontSize: '10px', color: 'grey' }} >
        Account
        <br />Details
      </th>
    </tr >
  );
};

const TableBody = (props) => {
  const account = props.data.orderSettledId?.settlement_account_details ? props.data.orderSettledId?.settlement_account_details
    : props.data.tipSettledId?.settlement_account_details ? props.data.tipSettledId?.settlement_account_details
      : props.data.expSettledId?.settlement_account_details ? props.data.expSettledId?.settlement_account_details
        : props.data.scanSettledId?.settlement_account_details;
  return (
    <tbody
      className="w-100"
    >
      <tr>
        {props.showStatus && <td style={{ width: "6%" }}>
          {props.data.overAllStatus === "COMPLETED" ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}
        </td>}
        <td style={{ width: "15%" }}>
          <div className=" text-break">
            <div className="f10-500">
              {props.data?.restaurant_id?.restaurant_name}
            </div>
            <div className="f10-400">{props.data?.restaurant_id?.city || ""}</div>
            {/* <div className="f8-400">{props.data?.restaurant_id?._id}</div> */}
          </div>
        </td>
        <td style={{ width: "14%" }}>
          <div className="f10-400">
            ₹ {props?.data?.orderSettledId?.total_amount?.toFixed(2) || 0}
          </div>
        </td>
        <td style={{ width: "14%" }}>
        <div className="f10-400">
            ₹ {props?.data?.expSettledId?.total_amount?.toFixed(2) || 0}
          </div>
        
        </td>
        <td style={{ width: "14%" }}>
        <div className="f10-400">
            ₹ {props?.data?.scanSettledId?.total_amount?.toFixed(2) || 0}
          </div>
        </td>
        <td style={{ width: "14%" }}>
        <div className="f10-400">
            ₹ {props?.data?.tipSettledId?.total_amount?.toFixed(2) || 0}
          </div>
         
        </td>
        <td style={{ width: "14%" }}>
          <div className="f10-400">
            ₹{" "}
            {Number.parseFloat(
              (props?.data?.scanSettledId?.total_amount || 0) +
              (props?.data?.orderSettledId?.total_amount || 0) +
              (props?.data?.tipSettledId?.total_amount || 0) +
              (props?.data?.expSettledId?.total_amount || 0)
            ).toFixed(2) || 0}
          </div>
        </td>
        <td style={{ width: "14%" }}>
          <div className="f10-400">
            {account?.account_type || ""} <br />
            Account
          </div>
        </td>
        <td style={{ width: "20%" }}>
          <div className="f10-400">
            {account?.account_number?.replace(/\d(?=\d{3})/g, "*") || ""} <br />
            {account?.account_ifsc?.replace(/\d(?=\d{1})/g, "*") || ""}
          </div>
        </td>
      </tr>
    </tbody>
  );
};
